import React from "react";

const MumbleGenerator = () => {
    return (
        <div>
            <h1>Mumble Generator</h1>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/mbOdmeCFIeY?si=Uyl6yM8k_GdkDSgf"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>
            <p><a href="https://assetstore.unity.com/packages/tools/audio/mumble-generator-319430">Asset Store Link </a>
            </p>

            <p>Bring life to your game dialogue with dynamic mumbling voiceovers—just like in games such as Animal
                Crossing, Undertale, Balatro, or Celeste. This lightweight and customizable tool transforms any text
                into expressive, gibberish-style speech, perfect for adding charm and personality to your characters.
                Nothing worse than a silent game, am I right?
            </p>
            <p>
                🎮 Works with Any Genre
                Whether you're making an RPG, platformer, visual novel, or cozy life sim, mumble voices can enhance
                immersion without needing full voice acting. Go for full voice acting once you make milion on your
                current game!
            </p>
            <p>
                ⚙️ Easy to Use
                Just plug it in, feed your text, and you're done! Minimal setup required, with clear documentation and
                an example to get you started fast. If you need any help feel free to text me.
            </p>
            <p>
                🎨 Highly Customizable
                Choose from two base styles—Animalese or Simple—or add your own custom audio clips for a unique sound.
                Tweak pitch, speed, and voice profiles to match any character or mood. You can also randomize it, if you
                feel like it.

            </p>
            💡 Lightweight by Design
            Built with performance in mind, this tool won’t bloat your project or slow things down.
            <p>
                Add charm and character to your dialogue with just a few clicks.
            </p>
        </div>
    )
        ;
};

export default MumbleGenerator;
